import EssentialDocuments from '@/components/EssentialDocuments/EssentialDocuments';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useAppDispatch, useAppSelector } from '@/lib/hooks/hooks';
import { closeDialog } from '@/redux/slices/pageSlice';
import { RootState } from '@/redux/store/store';

const EssentialDocumentsDialog = () => {
	const dispatch = useAppDispatch();
	const isOpen = useAppSelector(
		(state: RootState) => state.page.dialog?.type === 'viewEssentialDocuments'
	);

	return (
		<Dialog open={isOpen}>
			<DialogContent
				className="bg-white max-w-[700px] py-4 2xl:py-8"
				setModalOpen={() => {
					dispatch(closeDialog());
				}}
			>
				<h1 className="font-bold w-full text-[#596c76] capitalize">
					Essential documents
				</h1>
				<EssentialDocuments type={'dialog'} />
			</DialogContent>
		</Dialog>
	);
};

export default EssentialDocumentsDialog;
